<template>
  <v-fab
    :append-icon="mdiTag"
    app
    color="red"
    location="left bottom"
    size="x-large"
    text="HD Offers"
    tile
    variant="elevated"
  ></v-fab>
</template>

<script setup lang="ts">
import { mdiTag } from '@mdi/js'
</script>
